import { Box, Image, Text } from "@vinomofo/components";
import { infoBlocksData } from "./infoBlocksData";
import styled from "styled-components";

const InfoBlocksWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  width: 100%;
  // padding: 40px 20px;
  background: transparent;
  z-index: 109;
  // margin: -100px auto;
  position: relative;
  @media ${({ theme }) => theme.mq.max.mobile} {
    // margin: -60px auto;
    // padding: 10px 0px;
  }
`;

const InfoBlocksContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  width: 100%;
  background: #f1ecec;
  border-radius: 12px;
  padding: 40px;
  gap: 40px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);

  @media ${({ theme }) => theme.mq.max.tablet} {
    padding: 32px;
    gap: 32px;
  }

  @media ${({ theme }) => theme.mq.max.mobile} {
    flex-direction: column;
    padding: 24px;
    gap: 24px;
  }
`;

const Block = styled(Box)`
  flex: 1;
  text-align: center;
  padding: 20px;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-4px);
  }

  @media ${({ theme }) => theme.mq.max.mobile} {
    padding: 16px;
  }
`;

const IconWrapper = styled(Box)`
  margin-bottom: 16px;
  display: flex;
  justify-content: center;

  img {
    width: 64px;
    height: 64px;
    object-fit: contain;
  }
`;

const Heading = styled(Text)`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
  color: ${({ theme }) => theme.colors.text};

  @media ${({ theme }) => theme.mq.max.mobile} {
    font-size: 18px;
    margin-bottom: 8px;
  }
`;

const Divider = styled(Box)`
  width: 90%;
  height: 1px;
  background-color: #d0c5c5;
  margin: 0 auto 16px;
`;

const Description = styled(Text)`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 16px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.textSecondary};

  @media ${({ theme }) => theme.mq.max.mobile} {
    font-size: 14px;
  }
`;

export const InfoBlocks = () => {
  return (
    <InfoBlocksWrapper>
      <InfoBlocksContainer>
        {infoBlocksData.map((block, index) => (
          <Block key={index}>
            <IconWrapper>
              <Image src={block.imageUrl} alt={block.heading} />
            </IconWrapper>
            <Heading>{block.heading}</Heading>
            <Divider />
            <Description>{block.description}</Description>
          </Block>
        ))}
      </InfoBlocksContainer>
    </InfoBlocksWrapper>
  );
};
